// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 14) return "static/js/4df09b4a79966201b883.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"4e8c0c88db95ec2735d8","149":"9a80e0c221c163f6e05c","150":"4d5e9eb792dc2b989a50"}[chunkId] + ".chunk.js";
};